import React from 'react';
import PropTypes from 'prop-types';
import Stats from '@strava/ui/Stats';
import Stat from '@strava/ui/Stat';
import { Markup } from 'interweave';

import I18n from 'utils/I18n';
import ActivityIcon from 'components/ActivityIcon';
import styles from './styles.scss';

const Summary = ({
  name,
  date,
  type,
  detailedType,
  kudosCount,
  commentCount,
  achievementsCount,
  distance,
  elevation,
  time,
  calories
}) => {
  const activityType = type.toLowerCase();
  const translatedActivityType = I18n.t(
    `strava.activities.types_v2.${activityType}`
  );
  return (
    <div className={styles.summaryWrapper}>
      <div className={styles.dateType}>
        <span className={styles.typeText}>{translatedActivityType}</span>
        <time className={styles.date} dateTime={date}>
          {date}
        </time>
      </div>

      <div className={styles.headerText}>
        <h1 className={styles.name}>{name}</h1>
        <div className={`app-icon-wrapper ${styles.typeIconWrapper}`}>
          <ActivityIcon
            type={detailedType}
            size="small"
            title={`${translatedActivityType}`}
            className={styles.typeIcon}
          />
        </div>
      </div>

      <ul className={styles.iconListWrapper}>
        <li>
          <span className="app-icon icon-kudo icon-lg" title="kudos icon" />
          {kudosCount}
        </li>
        <li>
          <span
            className="app-icon icon-comment icon-lg"
            title="comment icon"
          />
          {commentCount}
        </li>
        <li>
          <span
            className="app-icon icon-achievement icon-lg"
            title="achievement icon"
          />
          {achievementsCount}
        </li>
      </ul>

      <Stats listClassName={styles.statsWrapper}>
        <Stat value={distance} label="Distance" type="stat-xl" />
        <Stat
          value={<Markup noWrap={true} content={time} />}
          label="Time"
          type="stat-xl"
        />
        {elevation && (
          <Stat value={elevation} label="Elevation" type="stat-xl" />
        )}
        {calories && (
          <Stat value={Math.ceil(calories)} label="Calories" type="stat-xl" />
        )}
      </Stats>
    </div>
  );
};

Summary.defaultProps = {
  elevation: null,
  calories: null
};

Summary.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  detailedType: PropTypes.string.isRequired,
  kudosCount: PropTypes.number.isRequired,
  commentCount: PropTypes.number.isRequired,
  achievementsCount: PropTypes.number.isRequired,
  distance: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  elevation: PropTypes.string,
  calories: PropTypes.number
};

export default Summary;
